import type { FormSchemaType } from '@/schema';
import { BulleAide, FieldRadioGroup, Question } from '@workspace/core-ts/components';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { useContent } from '@workspace/core-ts/hooks';
import { OUI_NON_INTEGER_OPTIONS } from '@workspace/utils';
import DOMPurify from 'dompurify';
import besoinContent from '../content/2-votre-besoin';

export default function VotreBesoin() {
    const methods = useSmartFormGlobal<FormSchemaType>();
    const r = useContent();

    return (
        <SmartFormGlobal
            {...methods}
            className="mx-auto"
        >
            <Question>
                <Question.Header>
                    <Question.Title>{r(besoinContent.protectionQuestion)}</Question.Title>
                </Question.Header>
                <BulleAide>
                    <h3 className="font-semibold">{r(besoinContent.protectionInfoTitle)}</h3>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(r(besoinContent.protectionInfoDetails) as string) }} />
                </BulleAide>
                <FieldRadioGroup
                    name="DemandeTarif.DevoirConseil.DevoirIC"
                    options={OUI_NON_INTEGER_OPTIONS}
                />
                <BulleAide>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(r(besoinContent.protectionInfoExplanation) as string) }} />
                </BulleAide>
            </Question>
        </SmartFormGlobal>
    );
}
